module.exports = __webpack_public_path__ + "static/media/12.2c29fd93.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/12.png
// module id = 1509
// module chunks = 0